// src/context/AuthContext.tsx
import { RegisterResponse } from '@/happypaws-shared/src/Authentication/models/RegisterResponse';
import React, { createContext, useContext, useState } from 'react';
import { authService } from 'services/auth.service';

interface AuthContextType {
  user: RegisterResponse | null;
  setUser: (user: RegisterResponse | null) => void;
  isAuthenticated: boolean;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType>({} as AuthContextType);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<RegisterResponse | null>(authService.getCurrentUser());

  const logout = () => {
    authService.logout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, isAuthenticated: !!user, setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
